<div class="settingsContent">
	<h2 class="nopadding nomargin mat-h2">
		{{ T.SETTINGS_STAGE_DESIGNER | translate }}
	</h2>
	<mat-divider style="margin-top: 10px" />
</div>
